import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 209  -  中断循环
 */

export default class EventLoopBreak extends EventBase {
  /**
   * 中断循环构造函数
   */
  constructor() {
    super()
    this.Parameter = ['0', '']
  }

  // #region 事件内主要的属性参数
  /**
   * 跳出的层数
   */
  get DivNumber() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set DivNumber(value) {
    // this.SetProperty(this.Parameter, '0', value.toString());
    this.Parameter && (this.Parameter[0] = value.toString())
  }
  //   // #endregion

  /**
   * 事件ID
   */
  Code = EventID.LoopBreak

  /**
   * 获得该事件在事件列表的描述信息
   */
  /// <returns>事件描述信息</returns>
}
